'use client';

import {
  useContext,
} from 'react';
import {
  MediaContext,
} from '@/core/context/media';

export function useMedia() {
  return useContext(MediaContext);
}
